module.exports = __webpack_public_path__ + "img/wx.207b0d79.jpg";